import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../../components/FormikControl/FormikControl';
import voucherServices from '../voucherServices';
import { useAlert } from '../../../../../../context/AlertContext';

import moment from 'moment';
import SelectParty from '../../party/components/SelectParty';
import { useKeyPress } from '../../../../../../hooks/useKeyPress';



function EditVoucherDateForm({data,callBack }) {
    const {AppAlert} = useAlert();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);
    const [party,setParty] = useState(null);

    const initialValues = {        
        voucherDate:moment().format(moment.HTML5_FMT.DATE),
        paymentDueDate:moment().format(moment.HTML5_FMT.DATE),
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            voucherDate:data.voucherDate?data.voucherDate:moment().format(moment.HTML5_FMT.DATE),
            paymentDueDate:data.paymentDueDate?data.paymentDueDate:moment().format(moment.HTML5_FMT.DATE),
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        voucherDate:Yup.string().required("Required"),
    });

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        let payload = {...values};
        voucherServices.save(payload).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            console.log(error);
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    useKeyPress('F2', updateData );
    
    return (
        <>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="xs"
            >
                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogContent>
                                        <div className="row p-3">
                                            {dialogStatus &&
                                                <div className="col-md-12 my-3" >
                                                    <FormikControl control="input" formik={formik} type="date" autoFocus
                                                        label="Voucher Date" name="voucherDate" 
                                                    />
                                                </div>
                                            }
                                            <div className="col-md-12  my-3" >
                                                <FormikControl control="input" formik={formik} type="date" 
                                                    label="Payment Due Date" name="paymentDueDate" 
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Update</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik)  */ }
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>
        </>
    )
}

export default EditVoucherDateForm